import { Injectable } from '@angular/core';
import { StateResetService as CoreStateResetService, StateResetFilter } from '@core/state-management/state-reset.service';
import { StateResetService as BcmStateResetService } from '@bcmServices/state-reset.service';
import { FacadeTableUiRegistry } from '@modules/bcm/@core/state-management/bcm-facade-table-ui-registry';
import { WidgetWrapperSharedService } from '@modules/bcm/@shared/components/widget-wrapper/widget-wrapper-shared.service';

/**
 * Resets tab-local BCM UI state when the active harbour tenant changes or is left.
 * Does not affect other browser tabs (each tab has its own Angular instance / sessionStorage).
 */
@Injectable({ providedIn: 'root' })
export class BcmTenantChangeResetService {

    private _activeTenantId: number | null = null;

    constructor(
        private _widgetWrapperSharedService: WidgetWrapperSharedService,
        private _facadeTableUiRegistry: FacadeTableUiRegistry,
    ) {}

    getActiveTenantId(): number | null {
        return this._activeTenantId;
    }

    setActiveTenantId(tenantId: number | null): void {
        this._activeTenantId = tenantId;
    }

    /**
     * Call before activating a different tenant in this tab (same tab harbour switch).
     */
    handleTenantActivation(nextTenantId: number, previousTenantId?: number | null): void {
        const previous = previousTenantId ?? this._activeTenantId;

        if (previous != null && previous > 0 && previous !== nextTenantId) {
            this.resetUiState();
        }

        this._activeTenantId = nextTenantId;
    }

    /**
     * Call when leaving a tenant context (overview, logout path, bcmService.reset).
     */
    handleLeavingTenantContext(): void {
        this.resetUiState();
        this._activeTenantId = null;
    }

    resetUiState(): void {
        this._facadeTableUiRegistry.resetAll();
        CoreStateResetService.reset(StateResetFilter.BCM);
        BcmStateResetService.reset();
        this._widgetWrapperSharedService.switchEditMode(false);
    }
}
